import Header from "./components/App/Header";
import { useState, useEffect } from "react";
import AppContext from "./components/Context/Context";
import { GlobalStateProvider } from "./components/Context/GlobalStateContext";
import { Route, Routes } from "react-router-dom";
import Home from "./components/Pages/Home";
import Login from "./components/Pages/Login";
import RequireAuth from "./components/Auth/RequireAuth";
import NotRequireAuth from "./components/Auth/NotRequireAuth";
import Signup from "./components/Pages/Signup";
import ForgotPassword from "./components/Pages/ForgotPassword";
import JobReview from "./components/Pages/JobReview";
import JobReviewMonthlyStats from "./components/Pages/JobReviewMonthlyStats";
import EmployeeRates from "./components/Pages/EmployeeRates";
import EmployeeBonusAndDeductions from "./components/Pages/EmployeeBonusAndDeductions";
import EmployeeView from "./components/Pages/EmployeeView";
import EmployeeSummary from "./components/Pages/EmployeeSummary";
import MNVMoverShiftData from "./components/Pages/MNVMoverShiftData";
import LogInUserName from "./components/App/LogInUserName";
import NotAccess from "./components/Pages/NotAccess";
import DamageClaims from "./components/Pages/DamageClaims";
import MaterialsTemplateType from "./components/Pages/MaterialsTemplateType";
import MaterialsListPrice from "./components/Pages/MaterialsListPrice";
import { NotificationsScreen } from "./components/Pages/NotificationsScreen";
import VRMNotificationTemplate from "./components/Pages/VMRNotificationTemplate";
import AddressUnit from "./components/Pages/AddressUnit";
import StoragePrice from "./components/Pages/StoragePrice";
import Mover from "./components/Pages/Mover";
import MoverRates from "./components/Pages/MoverRates";
import StorageRecord from "./components/Pages/StorageRecord";
import MoverTypes from "./components/Pages/MoverTypes";
import VanTypes from "./components/Pages/VanTypes";
import Vans from "./components/Pages/Vans";
import Rates from "./components/Pages/Rates";
import Discount from "./components/Pages/Discount";
import Campaign from "./components/Pages/Campaign";
import Holiday from "./components/Pages/Holiday";
import TimeSlot from "./components/Pages/TimeSlot";
import LargeVans from "./components/Pages/LargeVans";
import MinimumCharge from "./components/Pages/MinimumCharge";
import BankHoliday from "./components/Pages/BankHoliday";
import RecentJob from "./components/Pages/RecentJob";
import LocationStats from "./components/Pages/LocationStats";
import LocationMove from "./components/Pages/LocationMove";
import CampaignData from "./components/Pages/CampaignData";
import EmailTemplate from "./components/Pages/EmailTemplate";
import Slots from "./components/Pages/Slots";
import VanAvailability from "./components/Pages/VanAvailability";
import User from "./components/Pages/User";
import Locations from "./components/Pages/Locations";
import JoinUs from "./components/Pages/JoinUs";
import InvoiceData from "./components/Pages/InvoiceData";
import ReceiptsData from "./components/Pages/ReceiptsData";
import UserReview from "./components/Pages/UserReview";
import Pages from "./components/Pages/Pages";
import BlogArticle from "./components/Pages/BlogArticle";
import Calander from "./components/Pages/Calander";
import ContentLibrary from "./components/Pages/ContentLibrary";
import Clients from "./components/Pages/Clients";
import Support from "./components/Pages/Support";
import Quotes from "./components/Pages/Quotes";
import QuoteDetail from "./components/Pages/QuoteDetail";
import MarketingScore from "./components/Pages/MarketingScore";
import TippingDashboard from "./components/Pages/TippingDashboard";
import EarningsDashboard from "./components/Pages/EarningsDashboard";
import DriversDashboard from "./components/Pages/DriversDashboard";
import MyConversations from "./components/Pages/MyConversations";
import WAConversations from "./components/Pages/WAConversations";
import MoverUnavailability from "./components/Pages/MoverUnavailability";
import GeneralData from "./components/Pages/GeneralData";
import { ToastContainer } from "react-toastify";
import MaterialsJobs from "./components/Pages/MaterialsJobs";
// import "react-toastify/dist/ReactToastify.css";
import MoveTypeServiceQuestionOption from "./components/Pages/MoveTypeServiceQuestionOption";
import XML from "./components/Pages/XML";
import SiteMap from "./components/Pages/SiteMap";
import BlogAuthor from "./components/Pages/BlogAuthor";
import GeneralInfo from "./components/Pages/GeneralInfo";
import ProductFaqs from "./components/Pages/ProductFaqs";
import Products from "./components/Pages/Products";
import ProductCategory from "./components/Pages/ProductCategory";
import WarningsAndPerformanceIssue from "./components/Pages/WarningsAndPerformanceIssue";
import CourtesyLiveScreen from "./components/Pages/CourtesyLiveScreen";
import ProductReviews from "./components/Pages/ProductReviews";
import ContractorView from "./components/Pages/ContractorView";
import Orders from "./components/Pages/Orders";
import Customers from "./components/Pages/Customers";
import StatisticMenu from "./components/Pages/StatisticMenu";
import OrderInvoice from "./components/Pages/OrderInvoice";
import SystemConfiguration from "./components/Pages/SystemConfiguration";
import FinanceCategories from "./components/Pages/FinanceCategories";


function App() {
  const [logInUserName, setLogInUserName] = useState<string | undefined>("");

  const handleUserNameChange = (userName: string | undefined) => {
    setLogInUserName(userName);
  };

  const originalConsoleWarn = console.warn;
  console.warn = (...args: any[]) => {
    if (
      typeof args[0] === "string" &&
      args[0].includes("google.maps.places.Autocomplete is not available")
    ) {
      return;
    }
    originalConsoleWarn(...args);
  };

  return (
    <main>
      {/* <NotificationContainer /> */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
      />
      <GlobalStateProvider>
        <div className="App--main">
          <Header />
          <LogInUserName onUserNameChange={handleUserNameChange} />
          <div
            className={logInUserName == "" ? "Body--Main p-all0" : "Body--Main"}
          >
            <Routes>
              <Route
                path=""
                element={
                  <RequireAuth>
                    <Home />
                  </RequireAuth>
                }
              />
              <Route
                path="home"
                element={
                  <RequireAuth>
                    <Home />
                  </RequireAuth>
                }
              />
              <Route
                path="login"
                element={
                  <NotRequireAuth>
                    <Login />
                  </NotRequireAuth>
                }
              />
              <Route
                path="signup"
                element={
                  <NotRequireAuth>
                    <Signup />
                  </NotRequireAuth>
                }
              />
              <Route
                path="forgotpassword"
                element={
                  <NotRequireAuth>
                    <ForgotPassword />
                  </NotRequireAuth>
                }
              />
              <Route
                path="jobreview"
                element={
                  <RequireAuth>
                    <JobReview />
                  </RequireAuth>
                }
              />
              <Route
                path="jobreviewmonthlystats"
                element={
                  <RequireAuth>
                    <JobReviewMonthlyStats />
                  </RequireAuth>
                }
              />
              <Route
                path="employeerates"
                element={
                  <RequireAuth>
                    <EmployeeRates />
                  </RequireAuth>
                }
              />
              <Route
                path="employeebonusanddeductions"
                element={
                  <RequireAuth>
                    <EmployeeBonusAndDeductions />
                  </RequireAuth>
                }
              />
              <Route
                path="employeeview"
                element={
                  <RequireAuth>
                    <EmployeeView />
                  </RequireAuth>
                }
              />
              <Route
                path="contractorview"
                element={
                  <RequireAuth>
                    <ContractorView />
                  </RequireAuth>
                }
              />
              <Route
                path="statisticmenu"
                element={
                  <RequireAuth>
                    <StatisticMenu />
                  </RequireAuth>
                }
              />
              <Route
                path="employeesummary"
                element={
                  <RequireAuth>
                    <EmployeeSummary />
                  </RequireAuth>
                }
              />
              <Route
                path="employeetimelog"
                element={
                  <RequireAuth>
                    <MNVMoverShiftData />
                  </RequireAuth>
                }
              />
              <Route
                path="damageclaims"
                element={
                  <RequireAuth>
                    <DamageClaims />
                  </RequireAuth>
                }
              />
              <Route
                path="warningsandperformanceissue"
                element={
                  <RequireAuth>
                    <WarningsAndPerformanceIssue />
                  </RequireAuth>
                }
              />
              <Route
                path="marketingscore"
                element={
                  <RequireAuth>
                    <MarketingScore />
                  </RequireAuth>
                }
              />
              <Route
                path="materialstemplatetype"
                element={
                  <RequireAuth>
                    <MaterialsTemplateType />
                  </RequireAuth>
                }
              />
              <Route
                path="materialslistprice"
                element={
                  <RequireAuth>
                    <MaterialsListPrice />
                  </RequireAuth>
                }
              />
              <Route
                path="addressunit"
                element={
                  <RequireAuth>
                    <AddressUnit />
                  </RequireAuth>
                }
              />
              <Route
                path="storageprice"
                element={
                  <RequireAuth>
                    <StoragePrice />
                  </RequireAuth>
                }
              />

              <Route
                path="mynotifications"
                element={
                  <RequireAuth>
                    <NotificationsScreen />
                  </RequireAuth>
                }
              />
              <Route
                path="notificationtemplates"
                element={
                  <RequireAuth>
                    <VRMNotificationTemplate />
                  </RequireAuth>
                }
              />
              <Route
                path="clients"
                element={
                  <RequireAuth>
                    <Clients />
                  </RequireAuth>
                }
              />
              <Route
                path="support"
                element={
                  <RequireAuth>
                    <Support />
                  </RequireAuth>
                }
              />
              <Route
                path="location"
                element={
                  <RequireAuth>
                    <Locations />
                  </RequireAuth>
                }
              />
              <Route
                path="pages"
                element={
                  <RequireAuth>
                    <Pages />
                  </RequireAuth>
                }
              />
              <Route
                path="xml"
                element={
                  <RequireAuth>
                    <XML />
                  </RequireAuth>
                }
              />
              <Route
                path="blogarticle"
                element={
                  <RequireAuth>
                    <BlogArticle />
                  </RequireAuth>
                }
              />
              <Route
                path="blogauthor"
                element={
                  <RequireAuth>
                    <BlogAuthor />
                  </RequireAuth>
                }
              />
              <Route
                path="userReview"
                element={
                  <RequireAuth>
                    <UserReview />
                  </RequireAuth>
                }
              />
              <Route
                path="user"
                element={
                  <RequireAuth>
                    <User />
                  </RequireAuth>
                }
              />
              <Route
                path="rates"
                element={
                  <RequireAuth>
                    <Rates />
                  </RequireAuth>
                }
              />
              <Route
                path="mover"
                element={
                  <RequireAuth>
                    <Mover />
                  </RequireAuth>
                }
              />
              <Route
                path="moverrates"
                element={
                  <RequireAuth>
                    <MoverRates />
                  </RequireAuth>
                }
              />
              <Route
                path="movertypes"
                element={
                  <RequireAuth>
                    <MoverTypes />
                  </RequireAuth>
                }
              />
              <Route
                path="van"
                element={
                  <RequireAuth>
                    <Vans />
                  </RequireAuth>
                }
              />
              <Route
                path="discount"
                element={
                  <RequireAuth>
                    <Discount />
                  </RequireAuth>
                }
              />
              <Route
                path="campaign"
                element={
                  <RequireAuth>
                    <Campaign />
                  </RequireAuth>
                }
              />
              <Route
                path="holiday"
                element={
                  <RequireAuth>
                    <Holiday />
                  </RequireAuth>
                }
              />
              <Route
                path="timeslot"
                element={
                  <RequireAuth>
                    <TimeSlot />
                  </RequireAuth>
                }
              />
              <Route
                path="largevans"
                element={
                  <RequireAuth>
                    <LargeVans />
                  </RequireAuth>
                }
              />
              <Route
                path="emailtemplate"
                element={
                  <RequireAuth>
                    <EmailTemplate />
                  </RequireAuth>
                }
              />
              <Route
                path="generaldata"
                element={
                  <RequireAuth>
                    <GeneralData />
                  </RequireAuth>
                }
              />
              <Route
                path="minimumcharge"
                element={
                  <RequireAuth>
                    <MinimumCharge />
                  </RequireAuth>
                }
              />
              <Route
                path="bankholiday"
                element={
                  <RequireAuth>
                    <BankHoliday />
                  </RequireAuth>
                }
              />
              <Route
                path="recentjob"
                element={
                  <RequireAuth>
                    <RecentJob />
                  </RequireAuth>
                }
              />
              <Route
                path="locationstats"
                element={
                  <RequireAuth>
                    <LocationStats />
                  </RequireAuth>
                }
              />
              <Route
                path="locationmove"
                element={
                  <RequireAuth>
                    <LocationMove />
                  </RequireAuth>
                }
              />
              <Route
                path="vantypes"
                element={
                  <RequireAuth>
                    <VanTypes />
                  </RequireAuth>
                }
              />
              <Route
                path="storagerecord"
                element={
                  <RequireAuth>
                    <StorageRecord />
                  </RequireAuth>
                }
              />
              <Route
                path="campaigndata"
                element={
                  <RequireAuth>
                    <CampaignData />
                  </RequireAuth>
                }
              />
              <Route
                path="slots"
                element={
                  <RequireAuth>
                    <Slots />
                  </RequireAuth>
                }
              />
              <Route
                path="van_availability"
                element={
                  <RequireAuth>
                    <VanAvailability />
                  </RequireAuth>
                }
              />
              <Route
                path="allquotes"
                element={
                  <RequireAuth>
                    <Quotes />
                  </RequireAuth>
                }
              />
              <Route
                path="/quote_detail/:quoteId"
                element={
                  <RequireAuth>
                    <QuoteDetail />
                  </RequireAuth>
                }
              />
              <Route
                path="invoicedata"
                element={
                  <RequireAuth>
                    <InvoiceData />
                  </RequireAuth>
                }
              />
              <Route
                path="receiptsdata"
                element={
                  <RequireAuth>
                    <ReceiptsData />
                  </RequireAuth>
                }
              />

              <Route
                path="contentlibrary"
                element={
                  <RequireAuth>
                    <ContentLibrary />
                  </RequireAuth>
                }
              />
              <Route
                path="sitemap"
                element={
                  <RequireAuth>
                    <SiteMap />
                  </RequireAuth>
                }
              />
              <Route
                path="earningsdashboard"
                element={
                  <RequireAuth>
                    <EarningsDashboard />
                  </RequireAuth>
                }
              />
              <Route
                path="tippingdashboard"
                element={
                  <RequireAuth>
                    <TippingDashboard />
                  </RequireAuth>
                }
              />

              <Route
                path="myconversations"
                element={
                  <RequireAuth>
                    <MyConversations />
                  </RequireAuth>
                }
              />

              <Route
                path="waconversations"
                element={
                  <RequireAuth>
                    <WAConversations />
                  </RequireAuth>
                }
              />

              <Route path="joinus/:passcode" element={<JoinUs />} />
              <Route path="notaccess" element={<NotAccess />} />

              <Route
                path="calendar"
                element={
                  <RequireAuth>
                    <Calander />
                  </RequireAuth>
                }
              />

              <Route
                path="driverdashboard"
                element={
                  <RequireAuth>
                    <DriversDashboard />
                  </RequireAuth>
                }
              />

              <Route
                path="moverunavailability"
                element={
                  <RequireAuth>
                    <MoverUnavailability />
                  </RequireAuth>
                }
              />

              <Route
                path="servicequestions"
                element={
                  <RequireAuth>
                    <MoveTypeServiceQuestionOption />
                  </RequireAuth>
                }
              />

              <Route
                path="materialsjobs"
                element={
                  <RequireAuth>
                    <MaterialsJobs />
                  </RequireAuth>
                }
              />
              <Route
                path="courtesylivescreen"
                element={
                  <RequireAuth>
                    <CourtesyLiveScreen />
                  </RequireAuth>
                }
              />
              <Route
                path="generalinfo"
                element={
                  <RequireAuth>
                    <GeneralInfo />
                  </RequireAuth>
                }
              />

              <Route
                path="productcategory"
                element={
                  <RequireAuth>
                    <ProductCategory />
                  </RequireAuth>
                }
              />
              <Route
                path="products"
                element={
                  <RequireAuth>
                    <Products />
                  </RequireAuth>
                }
              />
              <Route
                path="productreview"
                element={
                  <RequireAuth>
                    <ProductReviews />
                  </RequireAuth>
                }
              />

              <Route
                path="orders"
                element={
                  <RequireAuth>
                    <Orders />
                  </RequireAuth>
                }
              />

              <Route
                path="customers"
                element={
                  <RequireAuth>
                    <Customers />
                  </RequireAuth>
                }
              />
              <Route
                path="orderinvoice"
                element={
                  <RequireAuth>
                    <OrderInvoice />
                  </RequireAuth>
                }
              />
              <Route
                path="systemconfiguration"
                element={
                  <RequireAuth>
                    <SystemConfiguration />
                  </RequireAuth>
                }
              />
              <Route
                path="financecategories"
                element={
                  <RequireAuth>
                    <FinanceCategories />
                  </RequireAuth>
                }
              />

              <Route
                path="*"
                element={
                  <NotRequireAuth>
                    <Login />
                  </NotRequireAuth>
                }
              />
            </Routes>
          </div>
        </div>
      </GlobalStateProvider>
    </main>
  );
}

export default App;
